import axios from 'axios'

export function getBrlChecklist(version) {
  return axios.get('/brl-checklists/' + version)
}

export function submitBrlChecklist(workOrderId, brlChecklistVersion, checklistData) {
  return axios.post(`/work-orders/${workOrderId}/brl-checklists/${brlChecklistVersion}`, checklistData)
}